import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import styled from 'styled-components';
import { getDifficulty } from '../../../redux/Settings/selectors';
import {
  getGameDifficulty,
  allCurrentPhaseGoalsDone,
  getPlayedClass,
} from '../../../redux/Game/selectors';
import InfoField from '../../baseComponents/InfoField';
import PhaseGoals from './PhaseGoals';
import BaseButton from '../../baseButton';
import { SettingsActions } from '../../../redux/Settings';

const BaseContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
`;

const MainContainer = styled.div`
  display: flex;
  flex: 2.7;
  flex-direction: row;
  flex-wrap: no-wrap;
  padding-right: 2em;
`;

const PhaseContainer = () => {
  const dispatch = useDispatch();
  const { currentPhase } = useSelector((state) => state.settings);
  const difficulty = useSelector((state) => getDifficulty(state));
  const gameDifficulty = useSelector((state) => getGameDifficulty(state));
  const playedClass = useSelector((state) => getPlayedClass(state));
  const allDone = useSelector((state) => allCurrentPhaseGoalsDone(state));
  return (
    <MainContainer>
      <BaseContainer flexDirection="column">
        <InfoField title="Playing on" info={playedClass.displayName} />
        <InfoField title="Roguelite difficulty" info={difficulty} />
      </BaseContainer>
      <BaseContainer>
        <InfoField title="Game difficulty" info={gameDifficulty} />
        <InfoField title="Phase" info={currentPhase} size="L" />
      </BaseContainer>
      <BaseContainer>
        <PhaseGoals />
        <BaseButton
          onClick={() => dispatch(SettingsActions.nextPhase())}
          alt="Start the game and roll some rules!"
          size="18"
          text="Next Phase"
          disabled={!allDone}
        />
      </BaseContainer>
    </MainContainer>
  );
};

export default PhaseContainer;
